module.exports = __webpack_public_path__ + "media/application/images/ui/logo-maori-no-strap-0f87515142c1a33e178ef3d38bd22647.png";